const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_LEVELS)

export const apiLoyaltyLevels = {
	fetchLoyaltyLevels: async (): Promise<IPointLoyaltyLevelModel[]> => {
		const { data } = await apiCommon<IPointLoyaltyLevel[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(d => LoyaltyLevel(d))
	},
}
